import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function Nosotros() {
  useEffect(() => { document.title = 'Nosotros — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Quiénes" titleAccent="Somos" subtitle="Conoce la misión, visión y valores que guían a Sttora." breadcrumb="Nosotros">
      <div className="section-label">Nuestra Historia</div>
      <div className="section-body">
        <p>Sttora nació con la convicción de que el comercio puede ser un vehículo real de bienestar humano. Desde nuestros inicios, hemos construido una red comercial que combina la eficiencia del mundo digital con la calidez del trato cercano.</p>
        <p>Operamos integrando tiendas de cercanía, centros de consolidación y plataformas digitales para llevar productos y servicios esenciales a las personas que más los necesitan, en sus propios términos y en su propio entorno.</p>
      </div>
      <hr className="section-divider" />
      <div className="section-label">Misión y Visión</div>
      <div className="manifesto-grid">
        <div className="manifesto-item"><span className="m-key">Misión</span><span className="m-connector">—</span><span className="m-value">Mejorar vidas</span></div>
        <div className="manifesto-item"><span className="m-key">Visión</span><span className="m-connector">—</span><span className="m-value">Impacto global</span></div>
        <div className="manifesto-item"><span className="m-key">Modelo</span><span className="m-connector">—</span><span className="m-value">Red directa</span></div>
        <div className="manifesto-item"><span className="m-key">Origen</span><span className="m-connector">—</span><span className="m-value">Latinoamérica</span></div>
      </div>
      <hr className="section-divider" />
      <div className="section-label">Valores de Marca</div>
      <div className="card-grid">
        {[
          { n:'01', t:'Eficiente, pero humana', b:'La tecnología al servicio de las personas, nunca al revés.' },
          { n:'02', t:'Escalable, pero cercana', b:'Crecemos manteniendo la calidez del trato directo.' },
          { n:'03', t:'Comercial, pero con propósito', b:'Cada transacción genera valor real en la comunidad.' },
          { n:'04', t:'Estructurada, pero orientada al bienestar', b:'El orden organizacional siempre al servicio del desarrollo humano.' },
        ].map(c => (
          <div className="card" key={c.n}>
            <div className="card-number">{c.n}</div>
            <div className="card-title">{c.t}</div>
            <div className="card-body">{c.b}</div>
          </div>
        ))}
      </div>
    </InnerLayout>
  );
}
